import React from "react";
import { Box, Typography } from "@mui/material";
import Breadcrumb from "../../components/common/breadcrumb/Breadcrumb";

const breadcrumb = ["Route Report"];

const RouteReport = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <Breadcrumb pageNameList={breadcrumb} />
      <Typography variant="subtitle2">Route Report</Typography>
    </Box>
  );
};

export default RouteReport;
